"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CRM = void 0;
const AxiosHttpRequest_1 = require("./core/AxiosHttpRequest");
const AgenciesService_1 = require("./services/AgenciesService");
const AgenciesMutationService_1 = require("./services/AgenciesMutationService");
const AgencySocialsService_1 = require("./services/AgencySocialsService");
const AgentsService_1 = require("./services/AgentsService");
const AgentSocialsService_1 = require("./services/AgentSocialsService");
const BlocklistService_1 = require("./services/BlocklistService");
const ChannelsService_1 = require("./services/ChannelsService");
const CreatorAgenciesService_1 = require("./services/CreatorAgenciesService");
const CreatorLabelsService_1 = require("./services/CreatorLabelsService");
const CreatorMergeService_1 = require("./services/CreatorMergeService");
const CreatorProgramsService_1 = require("./services/CreatorProgramsService");
const CreatorsService_1 = require("./services/CreatorsService");
const CreatorsImportService_1 = require("./services/CreatorsImportService");
const CreatorSocialsService_1 = require("./services/CreatorSocialsService");
const CurationService_1 = require("./services/CurationService");
const HealthService_1 = require("./services/HealthService");
const JobsService_1 = require("./services/JobsService");
const LabelsService_1 = require("./services/LabelsService");
const ManagersService_1 = require("./services/ManagersService");
const ManagerSocialsService_1 = require("./services/ManagerSocialsService");
const ManagersTeamsService_1 = require("./services/ManagersTeamsService");
const NotesService_1 = require("./services/NotesService");
const NotesCommentsService_1 = require("./services/NotesCommentsService");
const NotificationsService_1 = require("./services/NotificationsService");
const PaymentsService_1 = require("./services/PaymentsService");
const PermissionsService_1 = require("./services/PermissionsService");
const ProgramsService_1 = require("./services/ProgramsService");
const PublicCreatorsService_1 = require("./services/PublicCreatorsService");
const SavedViewsService_1 = require("./services/SavedViewsService");
const SearchCreatorService_1 = require("./services/SearchCreatorService");
class CRM {
    constructor(config, HttpRequest = AxiosHttpRequest_1.AxiosHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '',
            VERSION: config?.VERSION ?? '1.0.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.agencies = new AgenciesService_1.AgenciesService(this.request);
        this.agenciesMutation = new AgenciesMutationService_1.AgenciesMutationService(this.request);
        this.agencySocials = new AgencySocialsService_1.AgencySocialsService(this.request);
        this.agents = new AgentsService_1.AgentsService(this.request);
        this.agentSocials = new AgentSocialsService_1.AgentSocialsService(this.request);
        this.blocklist = new BlocklistService_1.BlocklistService(this.request);
        this.channels = new ChannelsService_1.ChannelsService(this.request);
        this.creatorAgencies = new CreatorAgenciesService_1.CreatorAgenciesService(this.request);
        this.creatorLabels = new CreatorLabelsService_1.CreatorLabelsService(this.request);
        this.creatorMerge = new CreatorMergeService_1.CreatorMergeService(this.request);
        this.creatorPrograms = new CreatorProgramsService_1.CreatorProgramsService(this.request);
        this.creators = new CreatorsService_1.CreatorsService(this.request);
        this.creatorsImport = new CreatorsImportService_1.CreatorsImportService(this.request);
        this.creatorSocials = new CreatorSocialsService_1.CreatorSocialsService(this.request);
        this.curation = new CurationService_1.CurationService(this.request);
        this.health = new HealthService_1.HealthService(this.request);
        this.jobs = new JobsService_1.JobsService(this.request);
        this.labels = new LabelsService_1.LabelsService(this.request);
        this.managers = new ManagersService_1.ManagersService(this.request);
        this.managerSocials = new ManagerSocialsService_1.ManagerSocialsService(this.request);
        this.managersTeams = new ManagersTeamsService_1.ManagersTeamsService(this.request);
        this.notes = new NotesService_1.NotesService(this.request);
        this.notesComments = new NotesCommentsService_1.NotesCommentsService(this.request);
        this.notifications = new NotificationsService_1.NotificationsService(this.request);
        this.payments = new PaymentsService_1.PaymentsService(this.request);
        this.permissions = new PermissionsService_1.PermissionsService(this.request);
        this.programs = new ProgramsService_1.ProgramsService(this.request);
        this.publicCreators = new PublicCreatorsService_1.PublicCreatorsService(this.request);
        this.savedViews = new SavedViewsService_1.SavedViewsService(this.request);
        this.searchCreator = new SearchCreatorService_1.SearchCreatorService(this.request);
    }
}
exports.CRM = CRM;
